module.exports = __webpack_public_path__ + "static/media/0010.76c8273e.jpg";